module.exports = __webpack_public_path__ + "img/khipu_logo.ee5d1ce.png";